var alignmentStyle = {"alignLeft":"kylKf","textWrapNowrap":"_8Twqi","alignRight":"EKQcN","alignCenter":"avp7Z","sizeFullWidth":"mG4Zm","renderedInTable":"_5944c","sizeOriginal":"fv4Ip","sizeContent":"aYhMJ","sizeSmall":"QzL2q","sizeSmallCenter":"m-fm1","flex":"lYT2K","LEFT":"FKOb9","CENTER":"rH1gC","RIGHT":"Wrzq1","AUTO":"JKQpO","JUSTIFY":"wI9em"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-5b2a79a8.js.map
